// Login
export const LOGIN_PAGE_SHOW_LOGIN_FORM = 'LOGIN_PAGE_SHOW_LOGIN_FORM';
export const RESET_LOGIN_PAGE = 'RESET_LOGIN_PAGE';
export const UPDATE_LOGIN_PAGE_FORM_FIELD = 'UPDATE_LOGIN_PAGE_FORM_FIELD';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

//  Web Form
export const GET_WEB_FORM_PAGE_REQUEST = 'GET_WEB_FORM_PAGE_REQUEST';
export const GET_WEB_FORM_PAGE_SUCCESS = 'GET_WEB_FORM_PAGE_SUCCESS';
export const GET_WEB_FORM_PAGE_ERROR = 'GET_WEB_FORM_PAGE_ERROR';

export const GET_WEB_FORM_INCIDENT_TYPES_REQUEST = 'GET_WEB_FORM_INCIDENT_TYPES_REQUEST';
export const GET_WEB_FORM_INCIDENT_TYPES_SUCCESS = 'GET_WEB_FORM_INCIDENT_TYPES_SUCCESS';
export const GET_WEB_FORM_INCIDENT_TYPES_ERROR = 'GET_WEB_FORM_INCIDENT_TYPES_ERROR';

export const GET_WEB_FORM_CATEGORIES_REQUEST = 'GET_WEB_FORM_CATEGORIES_REQUEST';
export const GET_WEB_FORM_CATEGORIES_SUCCESS = 'GET_WEB_FORM_CATEGORIES_SUCCESS';
export const GET_WEB_FORM_CATEGORIES_ERROR = 'GET_WEB_FORM_CATEGORIES_ERROR';

export const SUBMIT_WEB_FORM_PAGE_REQUEST = 'SUBMIT_WEB_FORM_PAGE_REQUEST';
export const SUBMIT_WEB_FORM_PAGE_SUCCESS = 'SUBMIT_WEB_FORM_PAGE_SUCCESS';
export const SUBMIT_WEB_FORM_PAGE_ERROR = 'SUBMIT_WEB_FORM_PAGE_ERROR';

export const RESET_WEB_FORM_PAGE_META = 'RESET_WEB_FORM_PAGE_META';
export const RESET_WEB_FORM_PAGE = 'RESET_WEB_FORM_PAGE';

// Rating Page
export const GET_RATING_CATERERS_REQUEST = 'GET_RATING_CATERERS_REQUEST';
export const GET_RATING_CATERERS_SUCCESS = 'GET_RATING_CATERERS_SUCCESS';
export const GET_RATING_CATERERS_ERROR = 'GET_RATING_CATERERS_ERROR';

export const SUBMIT_RATING_PAGE_REQUEST = 'SUBMIT_RATING_PAGE_REQUEST';
export const SUBMIT_RATING_PAGE_SUCCESS = 'SUBMIT_RATING_PAGE_SUCCESS';
export const SUBMIT_RATING_PAGE_ERROR = 'SUBMIT_RATING_PAGE_ERROR';

export const RESET_RATING_PAGE_META = 'RESET_RATING_PAGE_META';
export const RESET_RATING_PAGE = 'RESET_RATING_PAGE';